import React from 'react';

const Dash = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M24 0H0V24H24V0Z' fill='white' fillOpacity='0.01' />
      <path
        d='M5 12H19'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Dash;
